import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const ClientChatContext = createContext(null);

export const ClientChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [requestedSalon, setRequestedSalon] = useState(null);
  const [contextSalon, setContextSalon] = useState(null);
  const [selectedConversationId, setSelectedConversationId] = useState(null);

  const openChat = useCallback(() => {
    setRequestedSalon(null);
    setSelectedConversationId(null);
    setIsOpen(true);
  }, []);

  const openForSalon = useCallback((salon) => {
    setRequestedSalon(salon);
    setSelectedConversationId(null);
    setIsOpen(true);
  }, []);

  const closeChat = useCallback(() => {
    setIsOpen(false);
  }, []);

  const selectConversation = useCallback((conversationId) => {
    setSelectedConversationId(conversationId);
    setIsOpen(true);
  }, []);

  const clearRequestedSalon = useCallback(() => {
    setRequestedSalon(null);
  }, []);

  const value = useMemo(() => ({
    isOpen,
    requestedSalon,
    contextSalon,
    selectedConversationId,
    openChat,
    openForSalon,
    closeChat,
    setContextSalon,
    selectConversation,
    clearRequestedSalon,
  }), [
    clearRequestedSalon,
    closeChat,
    contextSalon,
    isOpen,
    openChat,
    openForSalon,
    requestedSalon,
    selectConversation,
    selectedConversationId,
  ]);

  return (
    <ClientChatContext.Provider value={value}>
      {children}
    </ClientChatContext.Provider>
  );
};

export const useClientChat = () => {
  const value = useContext(ClientChatContext);
  if (!value) {
    throw new Error('useClientChat must be used inside ClientChatProvider');
  }
  return value;
};

